import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2 text-2xl capitalize" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "text-sm font-extralight" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-2\"><div class=\"text-sm font-extralight\">Upcoming events</div><div class=\"flex mt-1\"><div class=\"p-1 mr-2 text-xs bg-gray-800 border rounded\">QT012</div><div class=\"p-1 mr-2 text-xs bg-gray-800 border rounded\">QT012</div><div class=\"p-1 text-xs bg-gray-800 border rounded\">QT012</div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_metric_bar = _resolveComponent("metric-bar")

  return (_openBlock(), _createBlock("div", {
    class: ["w-full h-full p-4 text-left border-4 border-transparent rounded shadow-md cursor-pointer hover:border-blue-500 bg-primary-dark focus:outline-none", { 'border-blue-500': _ctx.isActive }],
    "data-testid": `student-phase-progression-card-${_ctx.phase}`
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.formatPhase(_ctx.phase)), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.percentComplete) + "% complete", 1),
      _createVNode(_component_metric_bar, { value: _ctx.percentComplete }, null, 8, ["value"])
    ]),
    _hoisted_4
  ], 10, ["data-testid"]))
}